import { ChannelIcon } from '@weareopenr/component-library';
import dayjs from 'dayjs';
import JustEatLogo from 'src/assets/images/justeat-logo.svg';
import UberEatsLogo from 'src/assets/images/ubereats-logo.png';
import deliverooLogo from 'src/assets/images/deliveroo-logo.png';
import { IGetVenuesResponseData, IVenuePublishedChannels } from 'src/api/getVenues/types';
import { IVenueChannelRow, IVenueRow } from 'src/components/VenuesTab/types';
import { toIsoTimestamp } from 'src/helpers/toIsoTimestamp/toIsoTimestamp';
import styles from './mapVenuesToTable.module.scss';

const PUBLISH_DATE_FORMAT = 'DD/MM/YY HH:mm';

export const getChannelLogo = (channelName: string) => {
  switch (channelName) {
    case 'Just Eat':
      return <img className={styles['channel-logo']} src={JustEatLogo} alt={channelName} />;
    case 'Uber Eats':
      return <img className={styles['channel-logo']} src={UberEatsLogo} alt={channelName} />;
    case 'Deliveroo':
      return <img className={styles['channel-logo']} src={deliverooLogo} alt={channelName} />;
    default:
      return <ChannelIcon />;
  }
};

const formatPublishDate = (date?: string): string | undefined => {
  if (!date) return undefined;

  const parsed = dayjs(toIsoTimestamp(date));
  return parsed.isValid() ? parsed.format(PUBLISH_DATE_FORMAT) : undefined;
};

const mapChannelToRow = (
  venueId: string,
  channel: IVenuePublishedChannels,
  externalVenueIds: Map<string, string>,
): IVenueChannelRow => {
  const [latestPublishedMenu] = channel.menus ?? [];

  return {
    rowId: `${venueId}-${channel.external_system_id}`,
    venueId,
    name: channel.name,
    menu: latestPublishedMenu,
    externalVenueId: externalVenueIds.get(channel.external_system_id),
    lastPublishedDate: formatPublishDate(channel.last_published_date),
  };
};

const getExternalVenueIds = (venue: IGetVenuesResponseData): Map<string, string> =>
  new Map(
    (venue.external_identifiers ?? []).map((identifier) => [
      identifier.external_system_id,
      identifier.external_venue_id,
    ]),
  );

export const mapVenuesToTableRows = (venues: IGetVenuesResponseData[]): IVenueRow[] =>
  venues
    .map((venue) => {
      const externalVenueIds = getExternalVenueIds(venue);

      return {
        rowId: venue.venue_id,
        venueId: venue.venue_id,
        name: venue.name,
        isTrial: venue.is_trial,
        channels: (venue.published_channels ?? []).map((channel) =>
          mapChannelToRow(venue.venue_id, channel, externalVenueIds),
        ),
      };
    })
    .sort((a, b) => a.name.localeCompare(b.name));
